import { render, staticRenderFns } from "./ControlloQualita.vue?vue&type=template&id=580f4b66&scoped=true&"
import script from "./ControlloQualita.vue?vue&type=script&lang=js&"
export * from "./ControlloQualita.vue?vue&type=script&lang=js&"
import style0 from "./ControlloQualita.vue?vue&type=style&index=0&id=580f4b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f4b66",
  null
  
)

export default component.exports